import Box, { BoxProps } from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { PropsWithChildren } from 'react';

type PageWithActionsProps = BoxProps & {
  actionsComponent: React.ReactNode;
};

const PageWithActions: React.FC<PropsWithChildren<PageWithActionsProps>> = ({
  actionsComponent,
  children,
  ...props
}) => (
  <Box
    {...props}
    sx={{
      flexDirection: 'column',
      display: 'flex',
      width: '100%',
      gap: 3,
      ...props.sx,
    }}
  >
    {actionsComponent}
    <Divider flexItem />
    {children}
  </Box>
);

export default PageWithActions;
